import { useState, useEffect } from 'react';

export const isMobileBreakpoint = (): boolean => {
  const [isMatch, setMatch] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = `(min-width: 640px)`;
    const matchQueryList = window.matchMedia(mediaQuery);

    const onChange = (e: MediaQueryListEvent) => setMatch(e.matches);

    // Set initial match status
    setMatch(matchQueryList.matches);

    // Add event listener for changes
    matchQueryList.addEventListener('change', onChange);

    // Clean up event listener on unmount
    return () => matchQueryList.removeEventListener('change', onChange);
  }, []);

  return !isMatch;
};
